import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "package-container mb-3 p-2 rounded d-flex flex-wrap gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "outdated-quote-message"
}
const _hoisted_3 = { class: "fw-bold text-primary-blue me-2" }
const _hoisted_4 = { class: "text-primary-blue" }
const _hoisted_5 = {
  key: 0,
  class: "text-primary-blue fs-5 lh-1"
}

import { computed, type Component } from 'vue'
  import { useI18n } from 'vue-i18n'

  // Package Icons
  import AccommodationIcon from '@/assets/AccommondationIcon.vue'
  import SkipassIcon from '@/assets/SkipassIcon.vue'
  import EquipmentIcon from '@/assets/EquipmentIcon.vue'
  import TrainIcon from '@/assets/TrainIcon.vue'
  import TransferIcon from '@/assets/TransferIcon.vue'
  import PlaneIcon from '@/assets/PlaneIcon.vue'

  import { PackageEnum } from '@/config'

  // Function to normalize package codes
  
export default /*@__PURE__*/_defineComponent({
  __name: 'PackageContainer',
  props: {
    packageCode: {
      type: String,
      required: true,
    },
    bookingReference: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  const normalizePackageCode = (code: string): PackageEnum | null => {
    if (!code) return null
    const baseCode = code.split('_')[0]
    return Object.values(PackageEnum).includes(baseCode as PackageEnum)
      ? (baseCode as PackageEnum)
      : null
  }

  const props = __props

  const { t } = useI18n()

  // Check if we should show outdated quote message
  const showOutdatedQuoteMessage = computed(() => {
    return props.bookingReference?.startsWith('BO') && 
           props.packageCode && 
           !['PFPF', 'PFF'].includes(props.packageCode)
  })

  const packageDetails = computed((): Array<string> => {
    if (!props.packageCode) return []
    
    // Normalize the package code directly here
    const normalizedCode = normalizePackageCode(props.packageCode)

    switch (normalizedCode) {
      case PackageEnum.HS:
        return ['accommodation']
      case PackageEnum.HF:
        return ['flight', 'accommodation']
      case PackageEnum.HTT:
      case PackageEnum.HTTF:
        return ['train', 'transfer', 'accommodation']
      case PackageEnum.PF:
        return ['accommodation', 'skipass']
      case PackageEnum.PFF:
        return ['flight', 'accommodation', 'skipass']
      case PackageEnum.PFPF:
        return ['flight', 'accommodation', 'skipass', 'equipment']
      case PackageEnum.PFP:
        return ['accommodation', 'skipass', 'equipment']
      case PackageEnum.PFTT:
      case PackageEnum.PFTTNL:
        return ['train', 'transfer', 'accommodation', 'skipass']
      case PackageEnum.PFCS:
        return ['accommodation', 'skipassShort']
      case PackageEnum.PFPCS:
        return ['accommodation', 'skipass', 'equipmentShort']
      case PackageEnum.PFTTF:
      case PackageEnum.PFTTUK:
        return ['train', 'accommodation', 'skipass']
      case PackageEnum.PFPTTF:
      case PackageEnum.PFPTTNL:
      case PackageEnum.PFPTTUK:
        return ['train', 'accommodation', 'skipass', 'equipment']
      default:
        return []
    }
  })

  const getIconComponent = (item: string): Component | null => {
    const logos: Record<string, Component> = {
      accommodation: AccommodationIcon,
      skipass: SkipassIcon,
      skipassShort: SkipassIcon,
      equipment: EquipmentIcon,
      equipmentShort: EquipmentIcon,
      train: TrainIcon,
      transfer: TransferIcon,
      flight: PlaneIcon,
    }
    return logos[item] || null
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showOutdatedQuoteMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "fw-bold text-danger" }, "OUTDATED QUOTE IGNORE", -1)
        ])))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('reservations.formula')) + ": ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageDetails.value, (packageItem, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(packageItem)))),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(`reservations.${packageItem}`)), 1),
              (index < packageDetails.value.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " + "))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
  ]))
}
}

})